import {
	MuiThemeProvider,
	Select,
	Theme,
	createTheme,
	makeStyles,
	useTheme,
} from '@material-ui/core';
import React from 'react';
import { colors } from '../../../theme/theme';

interface GenericSelectValue {
	value: string;
	label: string;
}

const useStyles = makeStyles((theme: Theme) => ({
	errorMessage: {
		width: '202px',
		color: colors.red,
		fontSize: 14,
		marginLeft: 10,
		marginTop: 2,
	},
}));

const getSelectTheme = (defaultTheme: Theme) =>
	createTheme({
		overrides: {
			MuiSelect: {
				root: {
					marginLeft: 20,
				},
				select: {
					background: 'white !important',
				},
				icon: {
					top: 'calc(50% - 16px)',
					width: 32,
					height: 32,
				},
			},
			MuiInput: {
				root: {
					minWidth: '100%',
					minHeight: '100%',
				},
				underline: {
					borderBottomColor: colors.grayA20,
					'&:after': {
						borderBottomColor: defaultTheme.palette.primary.main,
					},
				},
			},
		},
	});

interface Props {
	placeholder: string;
	error?: string;
	options: GenericSelectValue[];
	selectedValue: string;
	dataCy?: string;
	additionalInputParams?: any;
	className?: string;
	setSelectedValue(value: string): void;
}

export const GenericSelect: React.FC<Props> = (props) => {
	const additionalInputParams = props.additionalInputParams || {};
	const classes = useStyles();
	const theme = useTheme();

	return (
		<MuiThemeProvider theme={getSelectTheme(theme)}>
			<Select
				native
				defaultValue={props.selectedValue || ''}
				onChange={(event) => {
						props.setSelectedValue(event.target.value as string)
					}
				}
				className={props.className}
				name={props.dataCy}
				data-cy={props.dataCy}
				displayEmpty
				error={(props.error && (props.error !== '' || props.error === undefined )) || false}
				{...additionalInputParams}
			>
				<option value="" disabled>
					{props.placeholder}
				</option>
				{props.options.map((option, index) => (
					<option key={index} value={option.value}>
						{option.label}
					</option>
				))}
			</Select>
			{ props.error === undefined  && props.error && props.error !== '' && (
				<div className={classes.errorMessage}>{props.error}</div>
			)}
		</MuiThemeProvider>
	);
};
